import React from "react";
import { AttachmentPayload } from "../../../../Types";
import ImageGeneration from "./ImageGeneration";
import { getFileExtension, getFileNameWithoutExtsnions } from "../../../../FileAttachmentHelper";


interface Props {
    attachmentFile: AttachmentPayload;
}
const AttachmentFileUploaded=(props: Props)=> {
  const { attachmentFile } = props;
  return attachmentFile?.type === "file" ? (
    <>
      {attachmentFile?.fileName.split(".")[0] && (
        <div className="d-flex flex-row containerFileUpload">
          <img
            className="me-3"
            src={
              getFileExtension(attachmentFile?.fileName)=== "pdf"
                ? "/Images/GetConversations/icn-pdf-light.svg"
                : getFileExtension(attachmentFile?.fileName) === "doc" ||  getFileExtension(attachmentFile?.fileName) === "docx"
                ? "/Images/GetConversations/icn-doc-light.svg"
                : "/Images/GetConversations/icn-xlsx-light.svg"
            }
          />
          <div className="d-flex flex-column fileName">
            <span>{getFileNameWithoutExtsnions(attachmentFile?.fileName || "")}</span>
            <span>.{ getFileExtension(attachmentFile?.fileName)}</span>
          </div>
        </div>
      )}
    </>
  ) :attachmentFile?.type === "image"&& (
    <div className="mt-2 mb-2">
      <ImageGeneration imageSrc={attachmentFile?.blobUrl||""} canDownload={attachmentFile?.canDownload} source="imageUpload"/>
    </div>
  );
}

export default AttachmentFileUploaded;
